module.exports = __webpack_public_path__ + "img/o.e3f1fe9b.jpg";